export default {
  // Tiêu đề trang
  'smsReport.title': 'Báo cáo SMS',
  'smsReport.subtitle': 'Báo cáo thống kê và phân tích gửi SMS',

  // Trường biểu mẫu
  'smsReport.form.timeRange': 'Khoảng thời gian',
  'smsReport.form.timeRangeRequired': 'Vui lòng chọn khoảng thời gian',
  'smsReport.form.startDate': 'Ngày bắt đầu',
  'smsReport.form.endDate': 'Ngày kết thúc',
  'smsReport.form.startTime': 'Thời gian bắt đầu',
  'smsReport.form.startTimeRequired': 'Vui lòng chọn thời gian bắt đầu',
  'smsReport.form.startTimePlaceholder': 'Vui lòng chọn thời gian bắt đầu',
  'smsReport.form.endTime': 'Thời gian kết thúc',
  'smsReport.form.endTimeRequired': 'Vui lòng chọn thời gian kết thúc',
  'smsReport.form.endTimePlaceholder': 'Vui lòng chọn thời gian kết thúc',
  'smsReport.form.taskName': 'Nhiệm vụ',
  'smsReport.form.taskNamePlaceholder': 'Vui lòng nhập tên nhiệm vụ',
  'smsReport.form.taskType': 'Loại',
  'smsReport.form.taskTypePlaceholder': 'Vui lòng chọn loại',
  'smsReport.form.groupBy': 'Nhóm theo',
  'smsReport.form.groupByTooltip': 'Chọn phương thức nhóm dữ liệu',

  // Loại nhiệm vụ
  'smsReport.taskType.all': 'Tất cả loại',
  'smsReport.taskType.bulk': 'Gửi hàng loạt',
  'smsReport.taskType.automation': 'Tự động hóa',
  'smsReport.taskType.ndc': 'Chưa nạp tiền',
  'smsReport.taskType.inactive': 'Người dùng không hoạt động',
  'smsReport.taskType.churn': 'Người dùng rời bỏ',
  'smsReport.taskType.vip': 'Nhiệm vụ VIP',
  'smsReport.taskType.welcome': 'SMS chào mừng',
  'smsReport.taskType.restorage': 'Nạp lại sau lần nạp đầu',
  'smsReport.taskType.birthday': 'Nhắc nhở sinh nhật',
  'smsReport.taskType.unknown': 'Không xác định',

  // Tùy chọn nhóm
  'smsReport.groupBy.day': 'Nhóm theo ngày',
  'smsReport.groupBy.month': 'Nhóm theo tháng',
  'smsReport.groupBy.task': 'Nhóm theo nhiệm vụ',

  // Nút bấm
  'smsReport.button.search': 'Tìm kiếm',
  'smsReport.button.reset': 'Đặt lại',
  'smsReport.button.export': 'Xuất báo cáo',

  // Thẻ thống kê
  'smsReport.stats.totalSend': 'Tổng số gửi',
  'smsReport.stats.successSend': 'Gửi thành công',
  'smsReport.stats.failSend': 'Gửi thất bại',
  'smsReport.stats.avgSuccessRate': 'Tỷ lệ thành công TB',
  'smsReport.stats.totalCost': 'Tổng chi phí',

  // Cột bảng
  'smsReport.table.task': 'Nhiệm vụ',
  'smsReport.table.type': 'Loại',
  'smsReport.table.taskName': 'Tên nhiệm vụ',
  'smsReport.table.taskType': 'Loại nhiệm vụ',
  'smsReport.table.sendCount': 'Số lượng gửi',
  'smsReport.table.successCount': 'Số thành công',
  'smsReport.table.failCount': 'Số thất bại',
  'smsReport.table.successRate': 'Tỷ lệ thành công',
  'smsReport.table.cost': 'Chi phí',
  'smsReport.table.date': 'Ngày',
  'smsReport.table.actions': 'Thao tác',
  'smsReport.table.viewLogs': 'Xem nhật ký',

  // Modal nhật ký
  'smsReport.logs.title': 'Nhật ký SMS',
  'smsReport.logs.time': 'Thời gian',
  'smsReport.logs.task': 'Nhiệm vụ',
  'smsReport.logs.user': 'Người dùng',
  'smsReport.logs.phone': 'Số điện thoại',
  'smsReport.logs.channel': 'Kênh',
  'smsReport.logs.status': 'Trạng thái',
  'smsReport.logs.receipt': 'Mã biên nhận',
  'smsReport.logs.statusPending': 'Chờ gửi',
  'smsReport.logs.statusSuccess': 'Thành công',
  'smsReport.logs.statusFailed': 'Thất bại',

  // Thông báo
  'smsReport.message.selectTimeRange': 'Vui lòng chọn khoảng thời gian',
  'smsReport.message.exportSuccess': 'Xuất thành công',
  'smsReport.message.exportFailed': 'Xuất thất bại',
  'smsReport.message.exporting': 'Đang xuất dữ liệu...',
  'smsReport.message.queryFailed': 'Truy vấn thất bại',
  'smsReport.message.noData': 'Không có dữ liệu',

  // Gợi ý
  'smsReport.hint.selectQuery': 'Vui lòng chọn điều kiện truy vấn và nhấp tìm kiếm',
  'smsReport.hint.exportNote': 'Chức năng xuất sẽ tạo file báo cáo định dạng Excel',
  'smsReport.hint.timeRangeLimit': 'Khoảng thời gian không được vượt quá 90 ngày',

  // Nhãn trạng thái
  'smsReport.status.high': 'Cao',
  'smsReport.status.medium': 'Trung bình',
  'smsReport.status.low': 'Thấp',

  // Đơn vị tiền tệ
  'smsReport.currency.usd': 'USD',
  'smsReport.currency.cny': 'CNY',
  'smsReport.currency.php': 'PHP',
  'smsReport.currency.vnd': 'VND',

  // Phân trang
  'smsReport.pagination.total': 'Tổng cộng {{total}} bản ghi'
};
